import { Timestamp } from '@angular/fire/firestore';
import { Geolocation } from './geolocation.model';

export interface Event {
  id?: string;

  name?: string;
  description?: string;

  startDateTime: Timestamp;
  endDateTime: Timestamp;

  groupId: string;
  groupName: string;

  requestedBy?: string;
  requestedById?: string;

  approvedBy?: string;
  approvedById?: string;

  bannerImage?: string | undefined;
  storagePath?: string;
  bannerAspectRatio?: number | undefined;

  location?: Geolocation;

  status?: EventStatus | undefined;

  isPrivate?: boolean | undefined;
  isRegistrationRequired?: boolean | undefined;
  isAttendByInvite?: boolean | undefined;

  maxAttendees?: number | undefined;
  maxAttendeesPerRegistrant?: number | undefined;
  attendeeCount?: number | undefined;

  events?: {
    [eventId: string]: {
      date: Timestamp;
      name: string;
      requestVolunteers?: boolean;
      volunteersRequired?: number;
      volunteerCriteria?: string;
      volunteersCount?: number;
    }
  } | undefined;

  created: Timestamp;
  modified: Timestamp;
}

export enum EventStatus {
  active = 'active',
  request = 'request',
  rejected = 'rejected',
  cancelled = 'cancelled',
  unknown = 'unknown',
}

export interface EventStats {
  id?: string;
  totalAttendees?: number;
  requests?: number;
  adults?: number;
  children?: number;
  attendingCount?: number;
  tentativeCount?: number;
  declinedCount?: number;
}
